document.addEventListener('DOMContentLoaded', function () {
  const popup_modal_container = document.getElementById('swiper-popup-container');
  
  // Thumbnail Gallery Init
  const thumbnail_gallery = new Swiper("#thumbnail-slider", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  // Main Gallery Init
  const main_gallery = new Swiper("#main-slider", {
    spaceBetween: 10,
    autoHeight: true,
    thumbs: {
      swiper: thumbnail_gallery,
    },
  });

  // Popup Modal Init
  var popup_gallery = new Swiper("#popup-slider", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  
  // Set Thumnail Height
  const thumb_width = jQuery("#thumbnail-slider .swiper-slide").first().width();
  jQuery("#thumbnail-slider .swiper-slide").height(thumb_width || 0);

  // Listen to slide on change event to play the video
  [main_gallery, popup_gallery].forEach(function(gallery){
    gallery.on('slideChange', function(){
      // Pause Videos
      pausePlayedVideo(gallery);

      // Play Current Slide Video
      const active_slide = gallery.slides[gallery.activeIndex];
      const media_type = active_slide.getAttribute('data-media-type');
      if(media_type !== 'image'){
        const video = active_slide.querySelector('deferred-media[loaded="true"] video');
        // if(video){
        //   video.play();
        // }else{
        //   active_slide.querySelector('deferred-media > button > .deferred-media__poster-button').click();
        // }
      }
    });
  });

  //Bind keyboard events for popup gallery
  document.addEventListener('keyup', function (event) {
    // If key is right
    if(event.key === 'ArrowRight'){
      jQuery('#popup-slider .swiper-button-next').click();
    }
    // If key is left
    if(event.key === 'ArrowLeft'){
      jQuery('#popup-slider .swiper-button-prev').click();
    }
  });

  // Bind Main Slider Slide Click Event (To open the popup slider)
  $("#main-slider .swiper-slide[data-media-type='image']").click(openPopup);

  // Close Popup
  $("#close-swiper-popup").click(closePopup);
  document.addEventListener('keyup', (e) => {
    // If key is Esc
    if(event.key === 'Escape'){
      closePopup();
    }
  });

  // Update slider based on the current selected variant
  if(current_variant){
    let media_id = current_variant?.featured_media?.id || '';
    updateSlideIndex(media_id);
  }
  document.addEventListener('variant:url:updated', function(e){
    const curr_variant = e?.detail?.variant;
    if(curr_variant){
      let media_id = curr_variant?.featured_media?.id || '';
      updateSlideIndex(media_id);
    }
  });

  /* To open modal popup  */
  function openPopup(){
    jQuery('.shopify-section-group-header-group').css('display', 'none');
    popup_modal_container.classList.add("open");
    popup_gallery.navigation.update();
    popup_gallery.slideTo(main_gallery.activeIndex);
  }

  /* To close modal popup  */
  function closePopup(){
    jQuery('.shopify-section-group-header-group').css('display', 'block');
    popup_modal_container.classList.remove("open");
    main_gallery.slideTo(popup_gallery.activeIndex);
  }

  /* To update the slide index */
  function updateSlideIndex(media_id = 0){
    const slide = document.querySelector(`#main-slider .swiper-slide[data-media-id="${media_id}"]`);
    if(slide){
      const slide_index = parseInt(slide.getAttribute('data-slide-index'));
      main_gallery.slideTo(slide_index);
    }
  }

  /* To Pause The Video */
  function pausePlayedVideo(gallery = null){
    if(gallery){
      gallery.slides.forEach((slide) => {
        const type = slide.getAttribute('data-media-type');

        // If the type video
        if(type === 'video'){
          const video = slide.querySelector('deferred-media[loaded="true"] video');
          if(video){
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
            if(isPlaying){
              video.pause();
            }
          }
        }

        // If the type is external video
        if(type === 'external_video'){
          const iframe = slide.querySelector('deferred-media[loaded="true"] iframe.js-youtube');
          if(iframe){
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    }
  }

  // Disabling the gallery loader
  jQuery(".slider-loader-wrap").hide();
});